import { render, staticRenderFns } from "./DiscountCouponsList.vue?vue&type=template&id=5e418958&scoped=true"
import script from "./DiscountCouponsList.vue?vue&type=script&lang=js"
export * from "./DiscountCouponsList.vue?vue&type=script&lang=js"
import style0 from "./DiscountCouponsList.vue?vue&type=style&index=0&id=5e418958&prod&lang=scss&scoped=true"
import style1 from "./DiscountCouponsList.vue?vue&type=style&index=1&id=5e418958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e418958",
  null
  
)

export default component.exports